module.exports = __webpack_public_path__ + "static/media/diseno-logo-barranquilla.82c5ddad.jpg";